import { PrizetImageAPI } from '../../interface/interface';
import { componentTypes, Schema } from '@data-driven-forms/react-form-renderer';
import { GridProps } from '@mui/system';

export interface ProductVariantSchemaData {
  onChanged?: (e, propertyName: string) => void,
  slug: string,
  productName: string,
  productDescription: string,
  brandId: string,
  published: boolean,
  images: PrizetImageAPI[],
  tags: any[],
  tagValues: any[],
  attributeValues: any[],
  brands: any[],
  attribute: any[],
  brand?: any,
  editData?: any,
  products: any[],
  salesPrice: number,
  originalPrice: number,
  availableUnits: number,
  buyingPrice: number,
  states: any[],
  additionalInfo: string[],
  productId: string,
  sellers: any[]
}



// xs, sm, md, lg, xl: Define the number of grid columns the item should span at different breakpoints (e.g., xs: 6 means the item spans 6 out of 12 columns on extra-small screens).
// spacing: Defines the space between grid items.
//   alignItems: Aligns items vertically (e.g., flex-start, center, flex-end).
//   justifyContent: Aligns items horizontally (e.g., flex-start, center, space-between).
//   direction: Defines the direction of the grid (e.g., row, column).
export const ProductVariantSchema = (props: ProductVariantSchemaData) => {
  const {
    tags,
    attribute: attributes,
    products,
    editData,
    states,
    sellers,
  } = props;
  return {
    fields: [
      {
        component: componentTypes.SELECT,
        label: 'Seller',
        placeholder: 'Select a seller',
        name: 'sellerId',
        required: true,
        options: sellers,
        disabled: false,
        FormFieldGridProps: { xs: 5.5 },
        initialValue: editData?.vendor?.id,
      },
      {
        component: componentTypes.SELECT,
        label: 'Product',
        placeholder: 'Select a product',
        name: 'productId',
        required: true,
        disabled: editData ? true : false,
        options: products?.map((product: any) => ({
          value: product.id,
          label: product.productName,
          key: product.id
        })),
        FormFieldGridProps: { xs: 5.5 },
        initialValue: editData?.product?.id,
      },
      {
        component: componentTypes.TEXT_FIELD,
        label: 'Sale Price',
        placeholder: 'Sale Price',
        name: 'salePrice',
        required: true,
        disabled: false,
        initialValue: editData?.salePrice,
        FormFieldGridProps: { xs: 5.5 },
      },
      {
        component: componentTypes.TEXT_FIELD,
        label: 'Original Price',
        placeholder: 'Original Price',
        name: 'originalPrice',
        required: true,
        disabled: false,
        initialValue: editData?.originalPrice,
        FormFieldGridProps: { xs: 5.5 },

      },
      {
        component: componentTypes.TEXT_FIELD,
        label: 'Available Units',
        placeholder: 'Available Units',
        name: 'availableUnits',
        required: true,
        disabled: false,
        initialValue: editData?.availableUnits || editData?.product?.quantity,
        FormFieldGridProps: { xs: 5.5 },

      },
      {
        component: componentTypes.TEXT_FIELD,
        label: 'Buying Price',
        placeholder: 'Buying Price',
        name: 'buyingPrice',
        required: false,
        disabled: false,
        initialValue: editData?.buyingPrice,
        FormFieldGridProps: { xs: 5.5 },

      },
      {
        component: componentTypes.CHECKBOX,
        label: 'Published ',
        placeholder: 'is Published',
        initialValue: editData?.published,
        name: 'published'
      },

      {

        component: 'product-selector',
        label: 'Products Attributes',
        name: 'attributes',
        initialValue: editData?.product?.productAttributes?.map((item) => ({
          productAttributeId: item?.id,
          productAttributeValueId:
            item?.productAttributeValues?.[0]?.id || item?.productAttributeValues?.[0]?.attributeValue?.id, // Use the first value if available
          productAttributeValue: item?.productAttributeValues?.[0]?.attributeValue?.value || item?.productAttributeValues?.[0]?.value,
        })) ?? [],
        attribute: editData?.product?.productAttributes ?? [],
        FormFieldGridProps: { xs: 12 },

      },
      {
        component: 'tags',
        options: tags.map((tag: {tagName: string, id: string}) => ({
          label: tag.tagName,
          value: tag.id
        })),
        placeholder: 'Tags',
        FormFieldGridProps: { xs: 12 },
        name: 'tags',
        initialValue: editData?.tags?.map((tag: any) => ({
          label: tag.tagName,
          value: tag.id
        })),
      },
      {
        component: 'tags',

        label: 'Delivery Location',
        name: 'states',
        options: states.map((state: {name: string, value: string}) => ({
          label: state.name,
          value: state.value
        })),
        initialValue: editData?.states?.map((state: {name: string, value: string}) => ({
          label: state.name,
          value: state.value
        }))
      },
      {
        component: componentTypes.TEXT_FIELD,
        rows: 4,
        multiline: true,
        label: 'Additional Info (One per line)',
        placeholder: 'Comes with warranty\nFree shipping',
        name: 'additionalInfo',
        initialValue: editData?.additionalInfo ? editData.additionalInfo?.join('\n') : ''
      },
      {
        component: 's3',
        name: 'images',
        initialValue: editData? editData?.images : []
      }
    ]
  } as Schema extends GridProps ? GridProps : never;
};
